import { render, staticRenderFns } from "./BuySell.vue?vue&type=template&id=7f7c6ae0&scoped=true"
import script from "./BuySell.vue?vue&type=script&lang=js"
export * from "./BuySell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7c6ae0",
  null
  
)

export default component.exports